//* 私有组件属性
import type { DrawEmitNextData } from "@/views/tool/components/sequence/src/types";

//* 响应事件声明
export const ModuleEmitsOption = {
    next: (_data: DrawEmitNextData) => true,
};
